export default "__VITE_ASSET__TaYdj07r__"